<template>
    <div>
        <div class='logo'>
            <DynamicImageContainer class="logo" :image='logo' :use_random_test_images='false'/>
        </div>
        <div class='footer-address'>
            <div>London (Head Office)</div>
            <div>2nd Floor, Atlas House</div>
            <div>173 Victoria Street</div>
            <div>London</div>
            <div>SW1E 5NA</div>
            <div>+44 (0) 207 598 7700</div>
        </div>
    </div>
</template>


<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";

export default {
    components: {DynamicImageContainer},
    data(){
        return{
            logo: 'logos/itim_shop_logo.svg'
        }
    },
    methods:{
        goToHome(){
            this.$router.push('/');
        }
    }
}
</script>


<style lang="scss" scoped>
.logo{
    width: 250px;
}

.footer-address{
    margin-top: 30px;
    display:flex;
    flex-direction: column;
    gap: 3px;
}
</style>